/**
 * Brand-aware <head> w runtime. Czyta aktywny brand (useBrand → runtimeConfig)
 * i ustawia atrybuty <html data-brand>, title template, theme-color, apple title,
 * favicon i OG site_name — bez rebuildu i bez FOUC (SSR + hydracja identyczne).
 * Wydzielone z app.vue jako composable, by dało się testować w izolacji (app.vue
 * pociąga useAuth/QueryClient/PWA, co czyni mountSuspended(app) kruchym).
 */
export function useBrandHead(): void {
  const brand = useBrand()
  useHead({
    htmlAttrs: { 'data-brand': brand.id, lang: 'pl' },
    titleTemplate: brand.seo.titleTemplate,
    meta: [
      { name: 'theme-color', content: brand.seo.themeColor },
      { name: 'apple-mobile-web-app-title', content: brand.name },
      { property: 'og:site_name', content: brand.name },
    ],
    link: [
      { rel: 'icon', type: 'image/svg+xml', href: brand.favicon.svg },
      { rel: 'icon', type: 'image/x-icon', href: brand.favicon.ico },
      { rel: 'apple-touch-icon', sizes: '180x180', href: brand.favicon.appleTouchIcon },
      // crossorigin wymagany także przy same-origin — fonty idą w trybie CORS.
      ...(brand.fontPreload ?? []).map(href => ({ rel: 'preload', as: 'font', type: 'font/woff2', href, crossorigin: '' }) as const),
    ],
  })
}
